module.exports = __webpack_public_path__ + "static/img/puting_1.741adcd.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/ad/puting_1.png
// module id = BDpB
// module chunks = 1